import Vue from "vue";
import Vuex from "vuex";
import dayjs from 'dayjs';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo : {
      userIdx : 0,
      userName : '',
      userLevel : '',
      userEmail : '',
      userHandphone:'',
      idxTbCoarch : 0
    },
    coachingDays:"",
    coachingTime : "",
    isCoarchingTime:false
  },
  mutations: {
    setUserInfoEmail(state,email){
      state.userInfo.userEmail = email;
    },
    setUserInfo(state,info){
      state.userInfo = info;
    },
    setCoachingDays(state,value){
      console.log("setCoachingDays",value);
      let weekday = ['일', '월', '화', '수', '목', '금', '토'];
      state.coachingDays = weekday[value];
    },
    setCoachingTime(state,value){

      const date1 = "2021-01-10 "+value.startTime;
      const date2 = "2021-01-10 "+value.endTime;

      const diffDate1 =  new Date(date1.replace(/-/g, "/"));
      const diffDate2 =  new Date(date2.replace(/-/g, "/"));
      const difference = diffDate2.getTime() - diffDate1.getTime();
      state.coachingTime = Math.floor((difference / (1000 * 60)));
    },
    setIsCoarchingTime(state,value){
        const today = dayjs(new Date());
        const target = dayjs(value);

        if(target.isBefore(today)){
          state.isCoarchingTime = true;
        }else{
          state.isCoarchingTime = false;
        }
    }
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()]
});
